import {motion} from 'framer-motion';
import {FaBrain,FaCouch,FaHandshake,FaUsers} from 'react-icons/fa';
import {useLanguage} from '../context/LanguageContext';

const CategoryCard = ({category}) => {
  const {t} = useLanguage();
  const Icon = category.icon;
  
  return (
    <motion.div
      whileHover={{scale: 1.05}}
      className="bg-white rounded-lg shadow-lg p-8 text-center"
    >
      <div className={`w-20 h-20 ${category.color} rounded-full flex items-center justify-center mb-6 mx-auto`}>
        <Icon className="text-white text-3xl" />
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-4">{t(category.titleKey)}</h3>
      <p className="text-gray-600 text-lg mb-4">{category.courses} {t('coursesCount')}</p>
      <div className="text-sm text-gray-500">
        {category.description}
      </div>
    </motion.div>
  );
};

const Categories = () => {
  const {t} = useLanguage();
  
  const categories = [
    {
      id: 1,
      titleKey: "psychotherapy",
      icon: FaCouch,
      courses: 45,
      color: "bg-purple-500",
      description: "Comprehensive psychotherapy training and techniques"
    },
    {
      id: 2,
      titleKey: "personalityAssessment",
      icon: FaBrain,
      courses: 32,
      color: "bg-blue-500",
      description: "Advanced personality assessment methods and tools"
    },
    {
      id: 3,
      titleKey: "collaborativeAssessment",
      icon: FaHandshake,
      courses: 28,
      color: "bg-green-500",
      description: "Collaborative assessment approaches and practices"
    },
    {
      id: 4,
      titleKey: "familyTherapy",
      icon: FaUsers,
      courses: 38,
      color: "bg-red-500",
      description: "Family therapy techniques and interventions"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{opacity: 0, y: 20}}
          animate={{opacity: 1, y: 0}}
          className="text-center mb-16"
        >
          <h1 className="text-5xl font-bold text-gray-900 mb-6">{t('categoriesTitle')}</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">{t('categoriesSubtitle')}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {categories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{opacity: 0, y: 20}}
              animate={{opacity: 1, y: 0}}
              transition={{delay: index * 0.1, duration: 0.5}}
            >
              <CategoryCard category={category} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Categories;